import { get, post, put, deleted } from '..';
import routes from './routes';

const PermissionServices = {
  getPermissions: async (params) => {
    const data = await get(routes.getPermissions, params);
    return data;
  },

  createPermission: async (permissionData) => {
    const data = await post(routes.createPermission, permissionData);
    return data;
  },

  updatePermission: async (permissionId, permissionData) => {
    const data = await put(routes.updatePermission.replace(':permission_id', permissionId), permissionData);
    return data;
  },

  deletePermission: async (permissionId) => {
    const data = await deleted(routes.deletePermission.replace(':permission_id', permissionId));
    return data;
  }
};

export default PermissionServices;